import { Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "evrideo-ag-grid-evrideo-header",
  templateUrl: "./ag-grid-evrideo-header.component.html",
  styleUrl: "./ag-grid-evrideo-header.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class AgGridEvrideoHeaderComponent {
  @Input() selectedCount = 0;
}
